import React from "react";

export const MarketplaceBookingContext = React.createContext({
    deliveryAreaProperties: null,
    offeredPrice: null,
    highlightOrderPanel: null
});
